import React, { useMemo } from "react";

import { mdiClose, mdiMagnify } from "@mdi/js";
import Icon from "@mdi/react";
import debounce from "lodash.debounce";
import { useTranslation } from "react-i18next";

import type { JSX } from "react";

interface MediaLibrarySearchProps {
  inputValue: string;
  setInputValue: (inputValue: string) => void;
  setSearch: (search: string) => void;
}

function MediaLibrarySearch({
  inputValue,
  setSearch,
  setInputValue,
}: MediaLibrarySearchProps): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");
  const debouncedSetSearch = useMemo(
    () =>
      debounce((searchText: string) => {
        setSearch(searchText);
      }, 500),
    [setSearch],
  );

  const handleSearchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setInputValue(event.target.value);
    debouncedSetSearch(event.target.value.trim());
  };

  const handleSearchReset = (): void => {
    setSearch("");
    setInputValue("");
  };

  return (
    <div className="relative my-[0.3125rem] min-h-[35px] w-full rounded-[0.3125rem]">
      <div className="text-muted-foreground pointer-events-none absolute inset-y-0 left-0 flex items-center pl-[0.46875rem]">
        <Icon path={mdiMagnify} size={0.9375} />
      </div>
      <input
        className="focus:ring-primary bg-card text-foreground placeholder:text-muted-foreground ring-input block size-full rounded-[0.3125rem] border-0 px-[2.1875rem] py-[0.234375rem] text-[0.9375rem] ring ring-1 ring-inset focus:ring-2 focus:ring-inset"
        id="search"
        name="search"
        onChange={handleSearchChange}
        placeholder={t("search")}
        type="text"
        value={inputValue}
      />
      <div
        className="text-subtle hover:text-muted-foreground absolute inset-y-0 right-[0.3125rem] flex cursor-pointer items-center"
        onClick={handleSearchReset}
      >
        <Icon path={mdiClose} size={0.9375} />
      </div>
    </div>
  );
}

export default MediaLibrarySearch;
